<template>
  <b-navbar toggleable="lg" type="dark" fixed="top" id="header" class="header">

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-brand class="mr-auto" :to="{name: 'landing'}">
      <img src="/static/img/songback-logo.svg" class="logo">
      <!--<img src="/static/img/sb-logo.svg" class="logo-small">-->
    </b-navbar-brand>

    <b-collapse is-nav id="nav-collapse">
      <b-navbar-nav class="flex-grow-1 justify-content-center">
        <b-nav-item :to="{name: 'site-about'}">About</b-nav-item>
        <b-nav-item :to="{name: 'discover'}">Browse</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav>
        <b-nav-item :to="{name: 'account-login', query: $route.query }">Log In</b-nav-item>
        <b-nav-item :to="{name: 'account-signup', query: $route.query }">Sign Up</b-nav-item>
      </b-navbar-nav>

    </b-collapse>
  </b-navbar>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  @include media-breakpoint-up(md) {
    #header {
      box-shadow: none;
    }
  }
</style>

<script>
export default {
  name: 'PublicHeader',
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/PublicHeader.vue